import i18n from './vue-i18n';
import vueBreadCrumbs from './vue-breadcrumbs';
import vueAxios from './vue-axios';
import apollo from './vue-apollo';
import vueTables from './vue-tables-2';
// import uiv from './uiv';
import element from './element';
import vueStorage from './vue-storage';
import veeValidate from './vee-validate';
import numeral from './numeral-js';
import vueWait from './vue-wait';
import vueTour from './vue-tour';
import vueAppInsights from './vue-application-insights';
import vueDni from './vue-dni';
import VueClipboard from './vue-clipboard2';

export default [
  i18n,
  vueBreadCrumbs,
  vueAxios,
  apollo,
  vueTables,
  // uiv,
  element,
  vueStorage,
  veeValidate,
  numeral,
  vueWait,
  vueTour,
  vueAppInsights,
  vueDni,
  VueClipboard,
];



// WEBPACK FOOTER //
// ./src/plugins/index.js